import { Grid, Tooltip, Typography } from "@material-ui/core";
import React, { useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import EmailOTInputModal from "./otp-input-modal";
import { Delete } from "@material-ui/icons";
import { deleteUserEmail } from "../../../../../../../features/post";
import { NotificationManager } from "react-notifications";
import AppModal, {
  PRIMARY_ACTION_VARIANTS,
} from "../../../../../modals/app-modal";
import EmailInputModal from "./email-input-modal";
import { isEmpty, isArray } from "lodash";

const EmailSection = ({ account, fetchAd }) => {
  const [displayEmailInputModal, setDisplayEmailInputModal] = useState(false);
  const [displayOtpInputModal, setDisplayOtpInputModal] = useState(false);
  const [displayDeleteEmailModal, setDisplayDeleteEmailModal] = useState(false);
  const [isUpdatingData, setIsUpdatingData] = useState(false);

  const onClickEditIcon = () => {
    sessionStorage.removeItem("emailUpdateToken");
    sessionStorage.removeItem("pendingEmailAddress");
    sessionStorage.removeItem("emailUpdateRetryTime");
    setDisplayEmailInputModal(true);
  };

  const onClickDeleteEmail = async () => {
    try {
      setIsUpdatingData(true);
      const response = await deleteUserEmail({ memberId: account.memberId });
      if (!response.success) {
        NotificationManager.error("Failed to delete email");
        return;
      }
      NotificationManager.success("Email Removed Successfully");
      fetchAd();
      setDisplayDeleteEmailModal(false);
    } catch (error) {
      console.log("Error >>>", error);
    } finally {
      setIsUpdatingData(false);
    }
  };

  const emailIncludedKeys = ["email", "email_sms"];

  const emailRemoveNotice =
    !isEmpty(account.pushNotificationPreferences) &&
    isArray(account.pushNotificationPreferences) &&
    account.pushNotificationPreferences.some((element) =>
      emailIncludedKeys.includes(element.option.id)
    )
      ? "Removing email will reset email notification preferences to the default settings. Are you sure you want to continue?"
      : "Are you sure you want to remove this email?";

  return (
    <>
      <Grid
        container
        alignItems="center"
        className="gap-x-8"
        style={{ paddingLeft: 15 }}
      >
        <i className="fas fa-at cursor-pointer" />
        <Typography
          variant="body2"
          className="cursor-pointer font-weight-600 ml-16"
          onClick={() => onClickEditIcon()}
        >
          {account.email ?? " - "}
        </Typography>
        {account.emailVerified && (
          <Tooltip title="Email Verified" placement="bottom" arrow>
            <i className="fas fa-check-circle id-vrified-badge" />
          </Tooltip>
        )}
        {account.email && (
          <Delete
            className="cursor-pointer"
            onClick={() => setDisplayDeleteEmailModal(true)}
          />
        )}
      </Grid>

      {displayEmailInputModal && (
        <EmailInputModal
          account={account}
          visibility={displayEmailInputModal}
          handleClose={() => setDisplayEmailInputModal(false)}
          setDisplayOtpInputModal={setDisplayOtpInputModal}
          setDisplayEmailInputModal={setDisplayEmailInputModal}
        />
      )}
      {displayOtpInputModal && (
        <EmailOTInputModal
          account={account}
          visibility={displayOtpInputModal}
          handleClose={() => setDisplayOtpInputModal(false)}
          setDisplayOtpInputModal={setDisplayOtpInputModal}
          setDisplayEmailInputModal={setDisplayEmailInputModal}
          fetchAd={fetchAd}
        />
      )}
      {displayDeleteEmailModal && (
        <AppModal
          visibility={displayDeleteEmailModal}
          handleClose={() => setDisplayDeleteEmailModal(false)}
          title="Remove Email"
          description={emailRemoveNotice}
          primaryLabel="Remove"
          onPrimaryAction={() => onClickDeleteEmail()}
          onSecondaryAction={() => setDisplayDeleteEmailModal(false)}
          actionType={PRIMARY_ACTION_VARIANTS.WARNING}
          loading={isUpdatingData}
        />
      )}
    </>
  );
};

export default EmailSection;
